export const CANVAS_DONE_REQUEST = "CANVAS_DONE_REQUEST";
export const CANVAS_DONE_SUCCESS = "CANVAS_DONE_SUCCESS";
export const CANVAS_DONE_FAILED = "CANVAS_DONE_FAILED";